function showDebugAlert(isOnSpecialPage) {

  if (window.location.pathname === '/collections/store-cupboard-extras') {
    window.location.href = '/cart';
    return false;
  }

  

  if (isOnSpecialPage) {
    $(".z_popup_container").addClass("active");
    $("div#cart-icon-bubble").click();
  } else {
    window.location.href = '/collections/store-cupboard-extras';
  }
}

function hideCartBar() {
  jQuery(".header__icons #cart-icon-bubble").removeClass("show");
  jQuery("#cart-icon-bubble .dropdown-menu").removeClass("show");
}

function showdeliverypopup(isOnSpecialPage) {
  fetch('/cart.js')
    .then(function(response) { return response.json(); })
    .then(function(cart) {
      var digitalOnly = cart.items.length > 0 && cart.items.every(function(item) {
        return item.gift_card === true;
      });

      if (digitalOnly) {
        window.location.href = '/checkout';
        return;
      }

      runDeliveryPopupCheck(isOnSpecialPage);
    })
    .catch(function() {
      // If the cart fetch fails for any reason, fall back to the normal delivery flow
      runDeliveryPopupCheck(isOnSpecialPage);
    });
}

function runDeliveryPopupCheck(isOnSpecialPage) {
  var valus = jQuery("input#Zapiet-InputCalendar__delivery").val();
  jQuery(".z_errorMessage").remove();

  if (jQuery("#delivery-date-picker #storePickupApp p.error").length !== 0) {
    jQuery('html, body').animate({
      scrollTop: jQuery("#storePickupApp").offset().top - 200
    }, 500);
  }else{
    if(valus != ""){
      $(".z_popup_container").addClass("active");
      $("div#cart-icon-bubble").click();
    }else{
      jQuery("#storePickupApp .Zapiet-InputWithPrefix__Wrapper").append('<div class="z_errorMessage">Please select a delivery date</div>');

      jQuery('html, body').animate({
        scrollTop: jQuery("#storePickupApp").offset().top - 200
      }, 500);
      
      // Optional: Focus on the input field
      jQuery("input#Zapiet-InputCalendar__delivery").focus();
    }
  }
}


$(document).ready(function(){
  $(document).on("click", "#z_closePopup", function(){
    $(".z_popup_container").removeClass("active");
  });

  $(document).on("click", "button#redirectToCheckout", function(){
    window.location.href = '/checkout';
  });
});




$(window).on("scroll", function () {
    if ($(this).scrollTop() > 30) {
        $(".section-header.shopify-section-group-header-group .header-wrapper").addClass("fixed");
    } else {
        $(".section-header.shopify-section-group-header-group .header-wrapper").removeClass("fixed");
    }
});






$(document).on('click', function(e) {
    // Target element
    const $menu = $(".header__icons #cart-icon-bubble .dropdown-menu.dropdown-menu-right");
    const $dropdown = $(".dropdown");

    // If clicked outside the menu AND outside the dropdown toggle icon
    if (!$menu.is(e.target) && $menu.has(e.target).length === 0 &&
        !$dropdown.is(e.target) && $dropdown.has(e.target).length === 0) {

        // Remove show class
        $(".dropdown.show").removeClass("show");
        $(".header__icons #cart-icon-bubble .dropdown-menu.dropdown-menu-right.show").removeClass("show");
    }
});




$(document).ready(function() {
  // Toggle the main mobile menu
  $('.mobile-nav__toggle').on('click', function() {
    $(this).next('.mobile-nav__menu').slideToggle();
  });

  // Toggle the sub-menus
  $('.mobile-nav__submenu-toggle').on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass('mobile-nav__submenu-toggle--open');
    $(this).next('.mobile-nav__submenu').slideToggle();
  });
});






// Card quantity Function
$(document).ready(function() {
    
    $(document).on('click', '.z_quantityBtnMinus', function(e) {
        e.preventDefault(); 
        var $input = $(this).closest('form').siblings('.product-form__input').find('.quantity__input');
        var $cartButton = $(this).parent().find('.z_quantityItemCount'); 

        if ($input.length === 0) {
            $input = $(this).parent().parent().find('.quantity__input'); 
        }

        var currentVal = parseInt($input.val());
        if (!isNaN(currentVal) && currentVal > 1) {
            $input.val(currentVal - 1).trigger('change'); 
            $($cartButton).text('(' + (currentVal - 1) + ')');
        }
    });

    
    $(document).on('click', '.z_quantityBtnPlus', function(e) {
        e.preventDefault(); 
        var $input = $(this).closest('form').siblings('.product-form__input').find('.quantity__input');
        var $cartButton = $(this).parent().find('.z_quantityItemCount'); 
        
        if ($input.length === 0) {
            $input = $(this).parent().parent().find('.quantity__input'); 
        }

        var currentVal = parseInt($input.val());

        if (!isNaN(currentVal)) {
            $input.val(currentVal + 1).trigger('change');
            $($cartButton).text('(' + (currentVal + 1) + ')');
        }
    });


    $(document).on('click', '.card-wrapper.card .wbproductdes variant-radios fieldset>div label', function(){
        console.log("Out");
        if(!$(this).hasClass("active")){
            $(this).parent().parent().parent().parent().parent().find('.quantity__input').val(1);
            $(this).parent().parent().parent().parent().parent().find('.z_quantityItemCount').text('(1)');
            console.log("In");
        }
    });


    // Product Card Slider
    const isHomePage = window.location.pathname === '/' || window.location.pathname === '';


    function initSlider() {
      $('.z-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000, 
        arrows: true,        
        dots: false,         
        infinite: true,
        pauseOnHover: true
      });
    }

    if (isHomePage) {
      setTimeout(initSlider, 1000); 
    } else {
      initSlider();
    }

});


jQuery(document).on('change', 'select[name="options[Gift Voucher]"]', function () {
    var giftValue = jQuery(this).val().replace(/£/g, '');
    jQuery("#giftVoucher").val(giftValue);
});




/* New Add To Cart Fucntion */

// class ProductCardCart {
//   constructor() {
//     this.cart = {}; 
//     console.log("ProductCardCart: Initializing...");
//     this.init();
//   }

//   async init() {
//     // 1. Fetch Cart
//     await this.fetchCart();
//     console.log("ProductCardCart: Cart fetched", this.cart);

//     // 2. Update UI
//     this.updateAllCards();

//     // 3. Bind Events
//     this.bindEvents();

//     // 4. Listen for other cart updates
//     document.addEventListener('cart:updated', () => {
//       this.fetchCart().then(() => this.updateAllCards());
//     });
//   }

//   async fetchCart() {
//     try {
//       const response = await fetch('/cart.js');
//       const cart = await response.json();
//       this.cart = {};
//       cart.items.forEach(item => {
//         this.cart[item.id] = item.quantity;
//       });
//     } catch (error) {
//       console.error('ProductCardCart: Error fetching cart:', error);
//     }
//   }

//   updateAllCards() {
//     const wrappers = document.querySelectorAll('.dynamic-cart-btns');
//     wrappers.forEach(wrapper => this.updateCardState(wrapper));
//   }

//   updateCardState(wrapper) {
//     const variantId = parseInt(wrapper.dataset.variantId);
//     const qtyInCart = this.cart[variantId] || 0;

//     const addBtn = wrapper.querySelector('.btn-add-to-cart');
//     const qtyWrapper = wrapper.querySelector('.qty-control-wrapper');
//     const input = wrapper.querySelector('.qty-input');
//     const btnSpan = addBtn.querySelector('span');

//     // Reset Spinner
//     this.setLoading(wrapper, false);

//     if (qtyInCart > 0) {
//       addBtn.classList.add('hidden');
//       qtyWrapper.classList.remove('hidden');
//       if(input) input.value = qtyInCart;
//     } else {
//       addBtn.classList.remove('hidden');
//       qtyWrapper.classList.add('hidden');
//       if(input) input.value = 0;
//     }
//   }

//   bindEvents() {
//     document.addEventListener('click', (e) => {
//       // Add Button
//       const addBtn = e.target.closest('.btn-add-to-cart');
//       if (addBtn) {
//         e.preventDefault();
//         e.stopPropagation(); // Stop theme JS
//         console.log("ProductCardCart: Add clicked");
//         this.handleAddToCart(addBtn.closest('.dynamic-cart-btns'));
//         return;
//       }

//       // Plus Button
//       const plusBtn = e.target.closest('.btn-plus');
//       if (plusBtn) {
//         e.preventDefault();
//         e.stopPropagation();
//         console.log("ProductCardCart: Plus clicked");
//         this.handleQuantityChange(plusBtn.closest('.dynamic-cart-btns'), 1);
//         return;
//       }

//       // Minus Button
//       const minusBtn = e.target.closest('.btn-minus');
//       if (minusBtn) {
//         e.preventDefault();
//         e.stopPropagation();
//         console.log("ProductCardCart: Minus clicked");
//         this.handleQuantityChange(minusBtn.closest('.dynamic-cart-btns'), -1);
//         return;
//       }
//     });

//     // Variant Changes
//     this.observeVariantChanges();
//   }

//   observeVariantChanges() {
//     const hiddenInputs = document.querySelectorAll('input.product-variant-id');
//     const observer = new MutationObserver((mutations) => {
//       mutations.forEach((mutation) => {
//         if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
//           const input = mutation.target;
//           const wrapper = input.closest('form').querySelector('.dynamic-cart-btns');
//           if (wrapper) {
//             wrapper.dataset.variantId = input.value;
//             this.updateCardState(wrapper);
//           }
//         }
//       });
//     });

//     hiddenInputs.forEach(input => observer.observe(input, { attributes: true }));
    
//     // Fallback: Listen for change events on the form itself
//     document.addEventListener('change', (e) => {
//         if(e.target.matches('input[name="id"]')) {
//            const wrapper = e.target.closest('form').querySelector('.dynamic-cart-btns');
//            if (wrapper) {
//                wrapper.dataset.variantId = e.target.value;
//                this.updateCardState(wrapper);
//            }
//         }
//     });
//   }

//   async handleAddToCart(wrapper) {
//     if(!wrapper) return;
//     const variantId = parseInt(wrapper.dataset.variantId);
//     this.setLoading(wrapper, true);

//     try {
//       const res = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
//       });

//       if (res.ok) {
//         this.cart[variantId] = (this.cart[variantId] || 0) + 1;
//         this.updateCardState(wrapper);
//         this.refreshGlobalElements();
//       } else {
//         console.error("Shopify API Error", await res.text());
//         this.setLoading(wrapper, false);
//       }
//     } catch (err) {
//       console.error(err);
//       this.setLoading(wrapper, false);
//     }
//   }

//   async handleQuantityChange(wrapper, delta) {
//     const variantId = parseInt(wrapper.dataset.variantId);
//     const currentQty = this.cart[variantId] || 0;
//     const newQty = currentQty + delta;
//     this.setLoading(wrapper, true);

//     try {
//       const res = await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ id: variantId.toString(), quantity: newQty })
//       });

//       if (res.ok) {
//         if (newQty <= 0) delete this.cart[variantId];
//         else this.cart[variantId] = newQty;
        
//         this.updateCardState(wrapper);
//         this.refreshGlobalElements();
//       } else {
//          this.setLoading(wrapper, false);
//       }
//     } catch (err) {
//       console.error(err);
//       this.setLoading(wrapper, false);
//     }
//   }

//   setLoading(wrapper, isLoading) {
//     const spinners = wrapper.querySelectorAll('.loading-overlay__spinner');
//     spinners.forEach(s => {
//       if(isLoading) s.classList.remove('hidden');
//       else s.classList.add('hidden');
//     });
//   }

//   refreshGlobalElements() {
//     // 1. Trigger common Shopify theme events (ajaxCart, etc)
//     document.dispatchEvent(new Event('cart:refresh'));
    
//     // 2. Fetch specific sections to update Header Cart Bubble
//     fetch('/?sections=cart-icon-bubble')
//       .then(res => res.json())
//       .then(data => {
//         if(data['cart-icon-bubble']) {
//           const bubble = document.getElementById('cart-icon-bubble');
//           if(bubble) {
//              // Create a temp div to parse HTML
//              const div = document.createElement('div');
//              div.innerHTML = data['cart-icon-bubble'];
//              // Find the specific count element and replace it
//              const newContent = div.querySelector('#cart-icon-bubble').innerHTML;
//              bubble.innerHTML = newContent;
//           }
//         }
//       });
//   }
// }

// // DELAY EXECUTION BY 1 SECOND
// setTimeout(() => {
//   window.productCardCart = new ProductCardCart();
// }, 1000);


$(document).ready(function() {
    function selectLastVariation() {
        $('.card-wrapper.card .wbproductdes variant-radios fieldset').each(function() {
            var $labels = $(this).find('div > label');
            if ($labels.length > 1) {
                var $lastLabel = $labels.last();
                
                // Prevent scroll by temporarily disabling focus/scroll behavior
                var originalFocus = $.fn.focus;
                $.fn.focus = function() { return this; }; // Disable focus temporarily
                
                // Save scroll position
                var scrollPos = $(window).scrollTop();
                
                // Trigger the actual click (this runs your Ajax)
                $lastLabel[0].click();
                
                // Restore scroll position immediately
                $(window).scrollTop(scrollPos);
                
                // Restore original focus
                $.fn.focus = originalFocus;
            }
        });
    }

    selectLastVariation();

    $(document).on('shopify:section:load', selectLastVariation);
});
